
class GrapeUIPlugin
{
	constructor(Grape, options)
	{
		this.Grape = Grape;
		this.options = options;

		Grape.UsersPlugin = this;
	}

	async onInit()
	{
		this.Grape.currentSession = null;
		this.Grape.currentSessionObservable = ko.observable(null);

		let data = await Grape.fetches.getJSON('/api/session/info', {}, { cache: 'no-cache' });
		if (data.status == 'OK')
		{
			this.Grape.config.public_settings = data.public_settings || {};
			this.setSession(data.session, null);
		}

		this.add_page_roles();
	}

	add_page_roles()
	{
		Grape.router.add_event_listener('beforeRouteEnter', this.check_page_roles);
	}

	check_page_roles(to, from)
	{
		const current_roles = Grape?.currentSession?.roles ?? [];
		const plugin_options = to?.route?.plugin_options?.['ui-ps-login'] ?? {};
		const roles = plugin_options?.roles ?? [];

		let redirect_url;
		redirect_url = plugin_options?.redirect_url ?? {
			name: `/ui/login`,
			bindings: {
				rr: encodeURIComponent(to.hash)
			},
			parameters: {}
		};

		if (roles.length > 0)
		{
			const is_match = current_roles?.some(r => roles.includes(r)) ?? false;
			if (is_match)
			{
				return true;
			}
			else
			{
				if (!Grape.currentSession)
				{
					return redirect_url;
				} else
				{
					Grape.alerts.alert({
						type: 'warning',
						title: 'Permission Denied',
						message: 'You do not have the necessary permissions to perform this action.'
					});
					return false;
				}
			}
		}
		else
		{
			return true;
		};
	}

	async setSession(session, trigger_hook = 'onSessionChange')
	{
		if (session == null)
		{
			Grape.currentSession = null;
			localStorage.removeItem('session_id');
			localStorage.removeItem('roles');
			localStorage.removeItem('username');
		}
		else
		{
			Grape.currentSession = JSON.parse(JSON.stringify(session));
			localStorage.setItem('session_id', session.session_id);
			if (session.roles)
				localStorage.setItem('roles', session.roles);
		}

		let loading_dialog = window.document.createElement('dialog');
		loading_dialog.innerHTML = `<p><i class="fa fa-spinner fa-spin-pulse" style="font-size:3rem;color:white"></i></p>`;
		loading_dialog.style.position = 'fixed';
		loading_dialog.style.width = '100vw';
		loading_dialog.style['max-width'] = '100vw';
		loading_dialog.style.height = '100vh';
		loading_dialog.style['max-height'] = '100vh';
		loading_dialog.style.border = 'none';
		loading_dialog.style.background = 'rgba(0, 0, 0, 0.2)';
		loading_dialog.style.display = 'flex';
		loading_dialog.style.flexDirection = 'column';
		loading_dialog.style.justifyContent = 'center';
		loading_dialog.style.alignItems = 'center';
		window.document.body.append(loading_dialog);

		let status_indicator = window.document.createElement('div');
		loading_dialog.appendChild(status_indicator);

		loading_dialog.showModal();
		await new Promise((resolve, reject) => setTimeout(resolve, 2)); /* Return to the event loop for the loading icon to show */
		let load_results = await this.injectPublishedAssets((loaded_counter, load_counter, error_counter) =>
		{
			status_indicator.innerHTML =
				`<div style="text-align: center;">Loading application...</div>` +
				`<div><progress max="${load_counter}" value="${loaded_counter}">${loaded_counter}/${load_counter}</progress></div>` +
				`<div style="text-align: center;">${parseInt((loaded_counter / load_counter * 100))} %</div>`
				;
		}, (error, asset) =>
		{
			console.error(`Error while loading ${asset.url}:`, error);
		});
		// load_results = Array.isArray(load_results) ? load_results : [];

		let error_counter = 0;
		let error_list = [];
		for (let res of load_results)
			if (res.status != 'OK')
			{
				error_counter++;
				error_list.push(res);
			}

		if (error_counter > 0)
		{
			const err_option_result = await new Promise((resolve, reject) =>
			{
				loading_dialog.style.background = 'rgb(50,75,75,1)';
				loading_dialog.innerHTML = `<p style="font-size: 2em; color: #ee5522;">There were errors while loading the application</i></p>`;
				const error_options_div = window.document.createElement('div');
				const btn_reload = window.document.createElement('button');
				btn_reload.style.fontSize = '1.2em';
				btn_reload.style.margin = '0.5em';
				btn_reload.style.padding = '0.5em';
				btn_reload.innerHTML = 'Try Again';
				btn_reload.onclick = () => { resolve('reload'); };
				error_options_div.appendChild(btn_reload);

				// TODO report error to platsoft?

				const btn_continue = window.document.createElement('button');
				btn_continue.innerHTML = 'Continue with broken system';
				btn_continue.style.fontSize = '1.2em';
				btn_continue.style.margin = '0.5em';
				btn_continue.style.padding = '0.5em';

				btn_continue.onclick = () => { resolve('continue'); };
				error_options_div.appendChild(btn_continue);

				const error_report_div = window.document.createElement('div');
				let html = `<p style="font-size: 0.9em; color: #ee5522; font-family: monospace;">The following files could not be loaded:<ul>`;
				html += error_list.map((e) =>
				{
					return `<li><span style="font-family: monospace; font-size: 0.9em; color: #ee5522;">${e.asset.url}</span></li>`;
				});
				html += '</ul></p>';
				error_report_div.innerHTML = html;


				loading_dialog.appendChild(error_options_div);
				loading_dialog.appendChild(error_report_div);
			});

			if (err_option_result == 'reload')
			{
				window.location.reload();
				return;
			}
		}

		this.Grape.currentSessionObservable(session);
		if (trigger_hook)
			await Grape.plugins.triggerPluginHooks(trigger_hook, [Grape.currentSession]);

		loading_dialog.close();
		loading_dialog.remove();

		if (window.location.hash && window.location.hash.length && window.Grape.router.pending_route)
			Grape.navigate(window.location.hash.substring(1));
	}

	async injectPublishedAssets(status_update_callback = null, error_callback = null)
	{
		let list;
		try
		{
			list = await Grape.fetches.getJSON('/api/server/asset-list');
		} catch (err)
		{
			console.warn('GET /api/server/asset-list failed', err);
			return [];
		}

		if (!list || !list.length)
			return [];

		let load_counter = 0;
		let loaded_counter = 0;
		let error_counter = 0;

		const promises = [];
		for (const i of list)
		{
			let promise = null;
			if (i.type == 'js')
			{
				promise = new Promise((resolve, reject) =>
				{
					const script = document.createElement('script');
					script.src = i.url;
					if (i.load_as_module !== false)
						script.type = 'module';
					script.onload = () =>
					{
						loaded_counter++;
						if (status_update_callback instanceof Function)
							status_update_callback(loaded_counter, load_counter, error_counter);
						resolve({ asset: i, status: 'OK' });
					};
					script.onerror = (err) =>
					{
						error_counter++;
						if (error_callback instanceof Function)
							error_callback(err, i);
						resolve({ asset: i, status: 'ERROR', error: err });
					};
					document.head.appendChild(script);
				});
			}
			else if (i.type == 'css')
			{
				promise = new Promise((resolve, reject) =>
				{
					const e = document.createElement('link');
					e.rel = 'stylesheet';
					e.href = i.url;
					e.onload = () =>
					{
						loaded_counter++;
						if (status_update_callback instanceof Function)
							status_update_callback(loaded_counter, load_counter, error_counter);
						resolve({ asset: i, status: 'OK' });
					};
					e.onerror = (err) =>
					{
						error_counter++;
						if (error_callback instanceof Function)
							error_callback(err, i);
						resolve({ asset: i, status: 'ERROR', error: err });
					};

					document.head.appendChild(e);
				});
			}
			if (promise)
			{
				promises.push(promise);
				load_counter++;
			}
		}

		const results = [];
		for (let promise of promises)
		{
			let result = await promise;
			results.push(result);
		}

		return results;
	}
}

export default GrapeUIPlugin;
